import { createMuiTheme } from "@material-ui/core/styles";
import { RelodeTheme, RelodeThemeOptions } from ".";

export const createRelodeTheme = (options?: RelodeThemeOptions): RelodeTheme => {
    const theme = createMuiTheme(options);
    return theme as RelodeTheme;
};
